import SectionMessage from '@atlaskit/section-message';
import { BodySmall, checkMILEligibilityFromOfferingsByEdition } from '@atlassian/mpac-primitives';
import capitalize from 'lodash/capitalize';
import { TEST_IDS } from '../constants';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export const MultiInstancePricingSectionMessage = props => {
  const enterprisePlanLabel = capitalize(props.enterprisePlan);
  const selectedPlanLabel = capitalize(props.selectedPlan);
  if (checkMILEligibilityFromOfferingsByEdition(props.eligibleOfferings, props.selectedPlan)) {
    return /*#__PURE__*/_jsx("div", {
      "data-testid": TEST_IDS.TWO_CLICK_MULTI_INSTANCE_PRICING_SECTION_MESSAGE,
      children: /*#__PURE__*/_jsx(SectionMessage, {
        appearance: "information",
        children: /*#__PURE__*/_jsxs(BodySmall, {
          children: ["Your ", enterprisePlanLabel, " edition of this app includes multi-instance pricing. Therefore, you\u2019ll only be charged for unique users across all instances."]
        })
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "data-testid": TEST_IDS.TWO_CLICK_MULTI_INSTANCE_PRICING_SECTION_MESSAGE,
    children: props.isStepReviewAndInstall ? /*#__PURE__*/_jsx(SectionMessage, {
      appearance: "warning",
      children: /*#__PURE__*/_jsxs(BodySmall, {
        children: ["If you choose the ", selectedPlanLabel, " edition, it won't include the multi-instance pricing that\u2019s included with your existing ", enterprisePlanLabel, " edition. After the 30 day free trial, you will charged for all users across all instances."]
      })
    }) : /*#__PURE__*/_jsx(SectionMessage, {
      appearance: "information",
      children: /*#__PURE__*/_jsxs(BodySmall, {
        children: ["Your existing ", enterprisePlanLabel, " edition includes multi-instance pricing, where you'll be charged only for unique users across all instances. However, if you select", ' ', selectedPlanLabel, ", this flexibility won\u2019t be available."]
      })
    })
  });
};